import { Text } from "@gravity-ui/uikit";
import classNames from "classnames";

import css from "./ProfileCard.module.scss";

export interface ProfileCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  children: React.ReactNode;
}

export const ProfileCard = ({
  title,
  className,
  children,
  ...props
}: ProfileCardProps) => {
  return (
    <div className={classNames(css.profileCardContainer, className)} {...props}>
      <Text variant="subheader-2">{title}</Text>
      {children}
    </div>
  );
};
